import React, { useState } from "react";

import { useNotify } from "react-admin";

import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";

import CancellationVisitWithoutFeesModal from "pages/customerFiles/components/CancellationVisitWithoutFeesModal";
import CustomerFileTargetStyles from "pages/customerFiles/components/CustomerFileTargetStatesInput/CustomerFileTargetStyles";

import { cancellationVisitWithoutFees } from "utils/api";

const useStyles = makeStyles(CustomerFileTargetStyles);

const CancellationVisitWithoutFees = ({ customerFile, getCustomerFileDetail }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const notify = useNotify();
  const classes = useStyles();

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleSubmitCancellation = async (values) => {
    const { status } = await cancellationVisitWithoutFees(customerFile.uuid, {
      payload: { cancellation_fee: values.cancellation_fee_id },
    });
    if (status < 200 || status >= 300) {
      closeModal();
      notify("Une erreur est survenue lors de l'annulation", "warning");
    } else {
      getCustomerFileDetail(customerFile.id);
      closeModal();
      notify("Annulé avec succès");
    }
  };

  return (
    <>
      <Box
        width="fit-content"
        className={classes.actionButton}
        onClick={() => {
          setIsModalOpen(true);
        }}
      >
        <CloseIcon className="ico ico-small" />
        <Typography className={classes.body2} variant="body2">
          Annuler sans facturation
        </Typography>
      </Box>
      {isModalOpen && (
        <CancellationVisitWithoutFeesModal
          isModalOpen={isModalOpen}
          closeModal={closeModal}
          handleSubmitCancellation={handleSubmitCancellation}
        />
      )}
    </>
  );
};

export default CancellationVisitWithoutFees;
